import Enums from 'utils/EnumsManager';
import { setStore } from 'utils/localStorage';
import { SET_PAGINATION_STATUS, SET_DATA, SET_OPTIONS, SET_ROW_SELECTION, SET_VIEWS, SET_ACTIVE_VIEW, SET_PAGE_SIZE, SET_SORTER, DELETE_SORTER_BY_VIEW, RESET_COLUMNS_AND_DATA } from './actionTypes';
import { getPageInfo, parseViewId, parseSetSorter, parseGetSorter, deleteSorter } from './utils';

const {
  PhantomId,
  DefaultPageConfigs,
  LocalStorageKeys,
  ObjectTypes,
} = Enums;
const { PageSize } = DefaultPageConfigs;
const { crmPageInfo } = LocalStorageKeys;
const { Leads, Accounts, Opportunities } = ObjectTypes;

const initialState = {
  activeViewId: {
    leads: parseViewId(Leads),
    accounts: parseViewId(Accounts),
    opportunities: parseViewId(Opportunities),
  },
  isShowPagination: true,
  columns: [],
  data: [],
  meta: {},
  selectedRowKeys: [],
  tableParams: {},
  selectedFieldOptions: [],
  views: [],
  sorters: {
    leads: parseGetSorter(Leads),
    accounts: parseGetSorter(Accounts),
    opportunities: parseGetSorter(Opportunities),
  },
  PageSizeValue: _.isNumber(getPageInfo().PageSizeValue) ? getPageInfo().PageSizeValue : PageSize,
};

const objectList = (state = initialState, action) => {
  switch (action.type) {
    case SET_PAGINATION_STATUS:
      return {
        ...state,
        isShowPagination: !state.isShowPagination
      };

    case RESET_COLUMNS_AND_DATA:
      return {
        ...state,
        columns: [],
        data: []
      };

    case SET_DATA:
      const {
        columns,
        data,
        meta,
        tableParams,
      } = action.payload;
      return {
        ...state,
        columns,
        data,
        meta,
        selectedRowKeys: [],
        tableParams,
      };


    case SET_ROW_SELECTION:
      const { selectedRowKeys } = action.payload;
      return {
        ...state,
        selectedRowKeys,
      };


    case SET_OPTIONS:
      const { selectedFieldOptions } = action.payload;
      return {
        ...state,
        selectedFieldOptions,
      };


    case SET_VIEWS:
      const { views } = action.payload;
      const viewAll = {
        id: PhantomId,
        view_name: 'My View',
        is_created_by_me: true,
        created_by_user: {}
      };
      return {
        ...state,
        views: [viewAll, ...views],
      };


    case SET_ACTIVE_VIEW:
      const { viewId, objectType } = action.payload;
      setStore(crmPageInfo, {
        ...getPageInfo(),
        activeViewId: {
          ...state.activeViewId,
          [objectType]: viewId,
        },
      });
      return {
        ...state,
        activeViewId: {
          ...state.activeViewId,
          [objectType]: viewId,
        },
      };

    case SET_PAGE_SIZE:
      const { PageSizeValue } = action.payload;
      setStore(crmPageInfo, {
        ...getPageInfo(),
        PageSizeValue,
      });
      return {
        ...state,
        PageSizeValue,
      };

    case SET_SORTER:
      const { sorter } = action.payload;
      setStore(crmPageInfo, {
        ...getPageInfo(),
        sorters: {
          ...state.sorters,
          [sorter.objectType]: parseSetSorter(state, sorter),
        },
      });
      return {
        ...state,
        sorters: {
          ...state.sorters,
          [sorter.objectType]: parseSetSorter(state, sorter),
        },
      };

    case DELETE_SORTER_BY_VIEW:
      const { id, type } = action.payload;
      setStore(crmPageInfo, {
        ...getPageInfo(),
        sorters: {
          ...state.sorters,
          [type]: deleteSorter(id, state.sorters, type),
        },
      });
      return {
        ...state,
        sorters: {
          ...state.sorters,
          [type]: deleteSorter(id, state.sorters, type),
        },
      };

    default:
      return state;
  }
};

export default objectList;



// WEBPACK FOOTER //
// ./src/views/ObjectList/flow/reducer.js